
(()=>{'use strict';
if(customElements.get('lectric-page-peel-v6'))return;
const editorStates=new Map();
customElements.define('lectric-page-peel-v6',class extends HTMLElement { connectedCallback(){if(this.cleanup)return;const root=this,ac=new AbortController(),signal=ac.signal;const config=JSON.parse(root.querySelector('[data-config]').textContent);
// Default mode is a deterministic, self-contained preset. Saved Custom settings
// are still in Shopify and become active again when Custom is selected.
const recommendedPreset={
 distance:520,mediaFrame:520,creaseTop:0,creaseRight:0,radius:28,bleed:38,
 speed:700,sheen:65,shadow:70,light:225,wiggle:true,
 paperMode:'gradient',paperColor:'#eef3f6',paperEnd:'#152637',
 paperAngle:135,paperStrength:35,paperBlend:'multiply'
};
if(config.layoutMode!=='custom')Object.assign(config,recommendedPreset);
// In top-of-page-only mode the peel should not follow the visitor while scrolling.
// Retain fixed rendering geometry so the canvas, crease, and hit targets stay aligned.
if (root.dataset.positionMode === 'scroll') {
 const syncTopVisibility = () => { root.dataset.awayFromTop = String(window.scrollY > 12); };
 syncTopVisibility();
 window.addEventListener('scroll', syncTopVisibility, {passive:true, signal});
 window.addEventListener('pageshow', syncTopVisibility, {signal});
}
const editorKey='lectric-peel-editor:'+config.themeId+':'+location.pathname+':'+root.id;
function readEditorState(){if(!config.designMode)return false;if(editorStates.has(editorKey))return editorStates.get(editorKey);try{return sessionStorage.getItem(editorKey)==='open'}catch(error){return false}}
function rememberEditorState(state){if(!config.designMode)return;editorStates.set(editorKey,state);try{sessionStorage.setItem(editorKey,state?'open':'closed')}catch(error){}}
const $=id=>root.querySelector('[data-peel="'+id+'"]'),stage=$('stage'),canvas=$('sheet'),ctx=canvas.getContext('2d'),texture=document.createElement('canvas'),tx=texture.getContext('2d'),handle=$('handle'),promo=$('promo'),clickthrough=$('clickthrough'),reduced=matchMedia('(prefers-reduced-motion: reduce)');
// Page Peel analytics: emit one GTM dataLayer event per real visitor interaction.
// Theme Editor interactions never count; GTM controls consent and GA4 delivery.
const trackEnabled=config.trackEvents!==false&&!config.designMode;
let impressionObserver=null,impressionSent=false;
function track(eventName,fields={}){
 if(!trackEnabled)return;
 try{
   window.dataLayer=window.dataLayer||[];
   window.dataLayer.push(Object.assign({
     event:eventName,
     peel_version:'v2',
     peel_id:root.id,
     peel_source_path:window.location.pathname
   },fields));
 }catch(error){/* Analytics must never interfere with Page Peel interaction. */}
}
function trackClickthrough(anchor,kind,interaction){
 try{
   const target=new URL(anchor.href,window.location.href);
   if(!/^https?:$/.test(target.protocol))return;
   track('page_peel_clickthrough',{
     link_type:kind,
     interaction_method:interaction,
     destination_url:target.origin+target.pathname
   });
 }catch(error){}
}
function trackImpression(){
 if(impressionSent||!trackEnabled)return;
 impressionSent=true;
 track('page_peel_impression');
 impressionObserver?.disconnect();
}

let lastEdge=-1,W=0,H=0,dpr=1,edge=58,opened=false,drag=null,anim=null,raf=0,idleStart=performance.now(),last=0,imageURL=null,mediaURL=null,mediaKind=null,videoAllowed=true;
let fullVideoFit=false,videoVisibleWidth=0,videoVisibleHeight=0; 
const foldRaster=document.createElement('canvas'),foldCtx=foldRaster.getContext('2d');let texturePixels=null;
const SQ=Math.SQRT2,value=id=>Number(config[id]),maxEdge=()=>Math.min(value('distance'),W*.96,H*.9),rest=()=>W<600?68:76;
const imageCache=new Map();let refreshTimer=0;
function refreshTexture(){clearTimeout(refreshTimer);refreshTimer=setTimeout(()=>{if(!root.isConnected||document.querySelector('cart-drawer.active'))return;if(drag||anim){refreshTexture();return}texturePage();texturePixels=tx.getImageData(0,0,texture.width,texture.height);wake()},150)}
function headerChanged(records){return records.some(record=>{const el=record.target.nodeType===1?record.target:record.target.parentElement;if(!el||el===root||root.contains(el))return false;if(record.type==='childList'&&[...record.addedNodes,...record.removedNodes].some(n=>n.nodeType===1&&n.matches('header,sticky-header,[id*="__header"],[id*="__brand_bar"],#cart-icon-bubble,cart-drawer')))return true;if(el.matches('cart-drawer'))return record.type==='attributes'&&record.attributeName==='class';return !!el.closest('header,sticky-header,[id*="__header"],[id*="__brand_bar"],#cart-icon-bubble')})}
const headerObserver=new MutationObserver(records=>{if(headerChanged(records))refreshTexture()});
headerObserver.observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','src','srcset','hidden','aria-label']});
function cachedImage(key,src){let entry=imageCache.get(key);if(entry)return entry.ready?entry.image:null;const image=new Image();entry={image,ready:false};imageCache.set(key,entry);image.crossOrigin='anonymous';image.onload=()=>{entry.ready=true;refreshTexture()};image.onerror=()=>{};image.src=src;return null}
function svgImage(el){
 const clone=el.cloneNode(true),originals=[el,...el.querySelectorAll('*')],copies=[clone,...clone.querySelectorAll('*')];
 originals.forEach((n,i)=>{const style=getComputedStyle(n);for(const prop of ['fill','fill-opacity','stroke','stroke-width','stroke-opacity','stroke-linecap','stroke-linejoin','opacity','color'])copies[i].style.setProperty(prop,style.getPropertyValue(prop))});
 clone.setAttribute('xmlns','http://www.w3.org/2000/svg');clone.setAttribute('width',el.getBoundingClientRect().width);clone.setAttribute('height',el.getBoundingClientRect().height);
 const source=new XMLSerializer().serializeToString(clone);return cachedImage(source,'data:image/svg+xml;charset=utf-8,'+encodeURIComponent(source));
}
function parseFinish(css){const probe=document.createElement('canvas');probe.width=probe.height=1;const c=probe.getContext('2d');c.fillStyle=css;c.fillRect(0,0,1,1);return c.getImageData(0,0,1,1).data}
function tintChannel(base,tint,alpha,mode){const b=base/255,t=tint/255;let mix=t;
if(mode==='multiply')mix=b*t;else if(mode==='soft-light')mix=t<=.5?b-(1-2*t)*b*(1-b):b+(2*t-1)*((b<=.25?((16*b-12)*b+4)*b:Math.sqrt(b))-b);
return base+(mix*255-base)*alpha}
function texturePage(){
 texture.width=Math.round(W*dpr);texture.height=Math.round(H*dpr);tx.setTransform(dpr,0,0,dpr,0,0);
 tx.fillStyle='#fff';tx.fillRect(0,0,W,H);tx.fillStyle=getComputedStyle(document.body).backgroundColor;tx.fillRect(0,0,W,H);
 const box=stage.getBoundingClientRect();let count=0;
 const walk=(el)=>{if(el===root||el.closest('lectric-page-peel-v6,cart-drawer')||['SCRIPT','STYLE','NOSCRIPT','CANVAS','IFRAME'].includes(el.tagName))return;
 const r=el.getBoundingClientRect();if(r.right<box.left||r.left>box.right||r.bottom<box.top||r.top>box.bottom)return;
 const s=getComputedStyle(el);if(s.display==='none'||s.visibility==='hidden'||Number(s.opacity)===0||el.matches('.visually-hidden,.sr-only,.screen-reader-text,[hidden]')||(r.width<=1&&r.height<=1&&s.overflow==='hidden')||s.clip==='rect(0px, 0px, 0px, 0px)')return;
 if(++count>700)return;
 const x=r.left-box.left,y=r.top-box.top;
 tx.save();tx.globalAlpha=Number(s.opacity);tx.beginPath();const radius=[s.borderTopLeftRadius,s.borderTopRightRadius,s.borderBottomRightRadius,s.borderBottomLeftRadius].map(v=>Math.min(r.width/2,r.height/2,parseFloat(v)||0));tx.roundRect(x,y,r.width,r.height,radius);tx.clip();
 const mask=s.maskImage||s.webkitMaskImage||'none';
 if(mask!=='none'){
  const url=mask.match(/url\(["']?(.*?)["']?\)/)?.[1];
  if(url){const image=cachedImage(url,url);if(image){const m=document.createElement('canvas');m.width=Math.max(1,Math.ceil(r.width*dpr));m.height=Math.max(1,Math.ceil(r.height*dpr));const mc=m.getContext('2d'),scale=Math.min(m.width/image.naturalWidth,m.height/image.naturalHeight),iw=image.naturalWidth*scale,ih=image.naturalHeight*scale;mc.drawImage(image,(m.width-iw)/2,(m.height-ih)/2,iw,ih);mc.globalCompositeOperation='source-in';mc.fillStyle=s.backgroundColor;mc.fillRect(0,0,m.width,m.height);tx.drawImage(m,x,y,r.width,r.height)}}
 }else if(s.backgroundColor!=='rgba(0, 0, 0, 0)'){tx.fillStyle=s.backgroundColor;tx.fillRect(x,y,r.width,r.height)}
 const tag=el.tagName.toLowerCase();
 if(tag==='img'&&el.complete&&el.naturalWidth){
  try{const src=el.currentSrc||el.src;const image=cachedImage(src,src);if(image){
    if(config.underside?.matchImageCrop!==false){
      // Capture the image as the browser renders it, including object-fit cover
      // and object-position. The old sampling stretched most cover images.
      const fit=s.objectFit||'fill';
      const nw=image.naturalWidth,nh=image.naturalHeight;
      let dw=r.width,dh=r.height;
      if(fit!=='fill'){
        let scale=fit==='cover'?Math.max(r.width/nw,r.height/nh):
          fit==='none'?1:Math.min(r.width/nw,r.height/nh);
        if(fit==='scale-down')scale=Math.min(1,scale);
        dw=nw*scale;dh=nh*scale;
      }
      const pos=(s.objectPosition||'50% 50%').trim().toLowerCase().split(/\s+/);
      const parts=pos.length===1?(pos[0]==='top'||pos[0]==='bottom'?["50%",pos[0]]:[pos[0],"50%"]):pos;
      const position=(v,space,axis)=>{
        if(v==='center')return space/2;
        if(v===(axis===0?'left':'top'))return 0;
        if(v===(axis===0?'right':'bottom'))return space;
        if(v.endsWith('%'))return space*(parseFloat(v)||0)/100;
        if(v.endsWith('px'))return parseFloat(v)||0;
        return space/2;
      };
      tx.drawImage(image,x+position(parts[0],r.width-dw,0),y+position(parts[1],r.height-dh,1),dw,dh);
    }else{
      let iw=r.width,ih=r.height,ix=x,iy=y;
      if(s.objectFit==='contain'){
        const scale=Math.min(r.width/image.naturalWidth,r.height/image.naturalHeight);
        iw=image.naturalWidth*scale;ih=image.naturalHeight*scale;
        ix+=(r.width-iw)/2;iy+=(r.height-ih)/2;
      }
      tx.drawImage(image,ix,iy,iw,ih);
    }
  }}catch(e){}
 }
 if(tag==='svg'){try{const image=svgImage(el);if(image)tx.drawImage(image,x,y,r.width,r.height)}catch(e){}tx.restore();return}
 tx.restore();
 for(const node of el.childNodes){if(node.nodeType===1){walk(node)}else if(node.nodeType===3&&node.textContent.trim()){
  const range=document.createRange();range.selectNodeContents(node);const tr=range.getBoundingClientRect();
  if(tr.width&&tr.height&&tr.height<parseFloat(s.lineHeight||s.fontSize)*1.7){tx.font=s.font||s.fontWeight+' '+s.fontSize+' '+s.fontFamily;tx.fillStyle=s.color;tx.textBaseline='top';tx.fillText(node.textContent.trim(),tr.left-box.left,tr.top-box.top)}
 }}
 };walk(document.body);
}
function hitHull(points){
const pts=points.slice().sort((a,b)=>a[0]-b[0]||a[1]-b[1]),cross=(o,a,b)=>(a[0]-o[0])*(b[1]-o[1])-(a[1]-o[1])*(b[0]-o[0]);
const lower=[],upper=[];for(const p of pts){while(lower.length>1&&cross(lower[lower.length-2],lower[lower.length-1],p)<=0)lower.pop();lower.push(p)}for(const p of pts.slice().reverse()){while(upper.length>1&&cross(upper[upper.length-2],upper[upper.length-1],p)<=0)upper.pop();upper.push(p)}lower.pop();upper.pop();return lower.concat(upper)
}
function project(u,f,r){const s=f-u,t=Math.min(Math.PI,s/r);return s<=Math.PI*r?f-r*Math.sin(t):f+s-Math.PI*r;}
function draw(){
// Preserve the original curled corner at rest and morph gradually into the selected endpoints.
// The first 12px of movement (including idle wiggle) remains unchanged.
const morphRange=Math.max(1,maxEdge()-rest()-12);
const morphProgress=Math.max(0,Math.min(1,(edge-rest()-12)/morphRange));
const creaseMorph=morphProgress*morphProgress*(3-2*morphProgress);
const requestedTop=Math.max(24,Math.min(W*.99,edge+(Number(config.creaseTop)||0)*creaseMorph));
const requestedRight=Math.max(24,Math.min(H*.99,edge+(Number(config.creaseRight)||0)*creaseMorph));
// When the full landscape video is visible, the reveal cannot extend beyond
// the video without showing empty space. Adjust the crease endpoints together.
const topEnd=fullVideoFit?Math.max(24,Math.min(requestedTop,videoVisibleWidth)):requestedTop;
const rightEnd=fullVideoFit?Math.max(24,Math.min(requestedRight,videoVisibleHeight)):requestedRight;
const topScale=topEnd/edge,rightScale=rightEnd/edge;
canvas.style.transformOrigin='top right';$('foldHit').style.transformOrigin='top right';
const creaseTransform='scale('+topScale+','+rightScale+')';
canvas.style.transform=creaseTransform;$('foldHit').style.transform=creaseTransform;
ctx.setTransform(dpr,0,0,dpr,0,0);ctx.clearRect(0,0,W,H);const f=edge/SQ,r=Math.min(value('radius')*(.18+.82*Math.max(0,(edge-rest())/(maxEdge()-rest()))),f/4),bleed=Math.max(0,Math.min(1,value('bleed')/100))*(W<600?.14:1); // Minimize mirrored/warped print-through on the mobile underside.

$('reveal').style.clipPath='polygon(100% 0,calc(100% - '+topEnd+'px) 0,100% '+rightEnd+'px)';
const strength=value('shadow')/100,angle=value('light')*Math.PI/180;
// Phase 1: localized shadows only. Texture mapping and fold geometry stay unchanged.
const realism=config.realism||{};
const contactEnabled=realism.contactEnabled!==false;
const contactOpacity=Math.max(0,Math.min(100,Number(realism.contactOpacity??30)))/100;
const contactBlur=Math.max(0,Math.min(40,Number(realism.contactBlur??15)));
const contactDistance=Math.max(0,Math.min(20,Number(realism.contactDistance??5)));
const foldEdgeStrength=Math.max(0,Math.min(100,Number(realism.foldEdgeStrength??22)))/100;
const foldEdgeFeather=Math.max(2,Math.min(30,Number(realism.foldEdgeFeather??12)));
const lightX=-Math.cos(angle)*.65,lightY=-Math.sin(angle)*.65;

const outline=[];for(let i=0;i<=80;i++){const u=f*i/80,p=project(u,f,r);outline.push([W-(p+u)/SQ,(p-u)/SQ])}for(let i=80;i>=0;i--){const u=f*i/80,p=project(u,f,r);outline.push([W-(p-u)/SQ,(p+u)/SQ])}
const foldPolygon='polygon('+hitHull(outline).map(p=>p[0]+'px '+p[1]+'px').join(',')+')';$('foldHit').style.clipPath=foldPolygon;
const clearance=2*r,offscreen=W*3+1000;
function shadowSilhouette(spread,opacity,blur,offsetX=0,offsetY=0){
 const points=[];
 for(const side of [1,-1])for(let i=0;i<=80;i++){
  const u=f*(side===1?i:80-i)/80,t=Math.min(Math.PI,(f-u)/r),z=r*(1-Math.cos(t)),p=project(u,f,r);
  points.push([W-(p+side*u)/SQ+(lightX+spread[0])*z+offsetX,(p-side*u)/SQ+(lightY+spread[1])*z+offsetY]);
 }
 ctx.save();ctx.beginPath();points.forEach(([x,y],i)=>i?ctx.lineTo(x-offscreen,y):ctx.moveTo(x-offscreen,y));ctx.closePath();
 ctx.fillStyle='#000';ctx.shadowColor='rgba(4,12,22,'+opacity*strength+')';ctx.shadowBlur=blur*dpr;ctx.shadowOffsetX=offscreen*dpr;ctx.shadowOffsetY=0;ctx.fill();ctx.restore();
}


shadowSilhouette([0,0],.15,12+clearance*.75);
shadowSilhouette([-.20,.20],.17,9+clearance*.40);
shadowSilhouette([.20,-.20],.10,7+clearance*.25);
// Layered contact penumbra: cast beneath the moving fold, never above the flap.
if(contactEnabled&&contactOpacity>0){
 shadowSilhouette([-.10,.16],contactOpacity,contactBlur,-contactDistance*.6,contactDistance*.75);
 shadowSilhouette([-.025,.06],contactOpacity*.38,Math.max(1,contactBlur*.44),-contactDistance*.3,contactDistance*.36);
}

const rasterScale=Math.min(dpr,(anim||drag)? .85:1.5),left=Math.max(0,Math.floor(W-edge-4)),rw=Math.ceil((W-left)*rasterScale),rh=Math.ceil(Math.min(H,edge+4)*rasterScale);
if(foldRaster.width!==rw||foldRaster.height!==rh){foldRaster.width=rw;foldRaster.height=rh}
const pixels=foldCtx.createImageData(rw,rh),out=pixels.data,src=texturePixels.data,tw=texture.width,th=texture.height;
const finishA=parseFinish(config.paperColor||'#eef3f6'),finishB=parseFinish(config.paperEnd||'#152637'),finishOpacity=Math.max(0,Math.min(1,(config.paperStrength??35)/100)),finishAngle=(config.paperAngle??135)*Math.PI/180;
const gx=Math.sin(finishAngle),gy=-Math.cos(finishAngle),gradientSpan=Math.max(.001,Math.abs(gx)+Math.abs(gy));
const paper=[237,241,238],dark=[16,25,34],sideColor=[12,21,32],shine=[255,253,246];
// Blend the captured page texture into the fold shading while staying opaque.
// Transparency here exposes the promotional VIDEO, not the page beneath it.
// At 0px, the previous opaque underside rendering is fully restored.
const seamBlendWidth=Math.max(0,Math.min(24,Number(config.underside?.seamBlend??10)));


const diagonals=new Array(rw+rh);
function lighting(u,theta){const back=theta>Math.PI/2,tangent=Math.min(1,theta/.95),fade=tangent*tangent*(3-2*tangent);
 const rimWidth=.22+foldEdgeFeather/42;
 const rimShade=foldEdgeStrength*.52*Math.exp(-Math.pow((theta-.83)/rimWidth,2))*fade;
 return {u,ink:back?bleed:1,fade,shade:(.015+.23*Math.exp(-Math.pow((theta-1.6)/.72,2))+.08*Math.exp(-Math.pow((theta-2.75)/.85,2))+(back?.035*(1-u/f):0))*(.45+.55*strength)*fade+rimShade,glow:(value('sheen')/100)*Math.exp(-Math.pow((theta-2.18)/.68,2))*fade};}
for(let d=-rw;d<rh;d++){const p=(W-left+d/rasterScale)/SQ;let primary=null,secondary=null;
 const flat=2*f-Math.PI*r-p;
 if(p>=f&&flat>=0&&flat<=f-Math.PI*r)primary=lighting(flat,Math.PI);
 if(p>=f-r&&p<=f){const q=Math.asin(Math.max(0,Math.min(1,(f-p)/r))),backU=f-r*(Math.PI-q);if(backU>=0)primary=lighting(backU,Math.PI-q);secondary=lighting(f-r*q,q)}
 if(p>f&&p<f+4){secondary=lighting(p,0);secondary.coverage=1-(p-f)/4}
 diagonals[d+rw]=[primary,secondary];}
for(let iy=0;iy<rh;iy++)for(let ix=0;ix<rw;ix++){
 const x=left+(ix+.5)/rasterScale,y=(iy+.5)/rasterScale,v=(W-x-y)/SQ,absV=Math.abs(v),entry=diagonals[iy-ix+rw];
 let surface=entry[0];if(!surface||absV>surface.u)surface=entry[1];if(!surface||absV>surface.u)continue;
 const blendT=config.paperMode==='solid'?0:Math.max(0,Math.min(1,.5+(((x-(W-edge))/edge-.5)*gx+(y/edge-.5)*gy)/gradientSpan));
 const finishAlpha=finishOpacity*(finishA[3]+(finishB[3]-finishA[3])*blendT)/255;
 // Fine registration only changes which page pixels are sampled under the flap.
// At the zero defaults, the original fold mapping remains pixel-identical.
const regX=Math.max(-20,Math.min(20,Number(config.underside?.offsetX)||0));
const regY=Math.max(-20,Math.min(20,Number(config.underside?.offsetY)||0));
// Fold canvas is displayed with an anisotropic top-right CSS scale.
 // Sample the page at the same DISPLAYED coordinates as the uncurled
 // paper; otherwise the texture and visible seam drift apart as the
 // configured crease top/right offsets change.
 const u=surface.u,
   sx=Math.max(0,Math.min(tw-1,(W-((u+v)/SQ)*topScale+regX)*dpr)),
   sy=Math.max(0,Math.min(th-1,(((u-v)/SQ)*rightScale+regY)*dpr));
 const x0=Math.floor(sx),y0=Math.floor(sy),x1=Math.min(tw-1,x0+1),y1=Math.min(th-1,y0+1),fx=sx-x0,fy=sy-y0;
 const i00=(y0*tw+x0)*4,i10=(y0*tw+x1)*4,i01=(y1*tw+x0)*4,i11=(y1*tw+x1)*4;
 const sideShade=(.018+.045*(v*v)/(f*f))*strength*surface.fade,pos=(iy*rw+ix)*4;
 // Near the seam use real captured page colors, fading into the styled fold
// rather than fading alpha. Preserve the original edge antialiasing only.
const seamFraction=seamBlendWidth>0?Math.max(0,Math.min(1,(f-u)/seamBlendWidth)):1;
const seamEase=seamFraction*seamFraction*(3-2*seamFraction);
for(let c=0;c<3;c++){
 const top=src[i00+c]+(src[i10+c]-src[i00+c])*fx,bottom=src[i01+c]+(src[i11+c]-src[i01+c])*fx,sample=top+(bottom-top)*fy;
 let color=paper[c]+(sample-paper[c])*surface.ink;
 color=tintChannel(color,finishA[c]+(finishB[c]-finishA[c])*blendT,finishAlpha,config.paperBlend||'multiply');
 color+=(dark[c]-color)*surface.shade;
 color+=(sideColor[c]-color)*sideShade;
 const shaded=color+(shine[c]-color)*surface.glow;
 out[pos+c]=sample+(shaded-sample)*seamEase;
}
out[pos+3]=Math.round(255*(surface.coverage===undefined?1:surface.coverage));
}
foldCtx.putImageData(pixels,0,0);ctx.save();ctx.imageSmoothingEnabled=true;ctx.imageSmoothingQuality='high';ctx.drawImage(foldRaster,left,0,rw/rasterScale,rh/rasterScale);ctx.restore();

const tip=project(0,f,r)/SQ;const handleX=W-tip-28,handleY=Math.max(0,tip-28),handleCenterX=handleX+28,handleCenterY=handleY+28;handle.style.left=(W+(handleCenterX-W)*topScale-28)+'px';handle.style.top=(handleCenterY*rightScale-28)+'px';handle.style.right='auto';handle.style.width='56px';handle.style.height='56px';
// Media is intentionally not modified here: opening the curl changes only
// the reveal clipping and folded paper, never the video camera or its frame.
}
function frame(now){raf=0;if(!root.isConnected||document.hidden)return;if(!anim&&!drag&&!opened&&now-last<33){raf=requestAnimationFrame(frame);return;}if(anim){let p=Math.min(1,(now-anim.start)/anim.duration);let eased=p*p*p*(10+p*(-15+6*p));edge=anim.from+(anim.to-anim.from)*eased;if(p===1){anim=null;edge=opened?maxEdge():rest();idleStart=now+1400}}else if(!drag&&!opened){const cycle=(now-idleStart)%6500;edge=rest()+(!reduced.matches&&config.wiggle&&cycle>=0&&cycle<1700?7*Math.sin(cycle/1700*Math.PI)**2*Math.sin(cycle/1700*Math.PI*3):0)}if(anim||drag||opened||edge!==lastEdge){draw();lastEdge=edge;}if(anim||(!drag&&!opened&&!reduced.matches&&config.wiggle))raf=requestAnimationFrame(frame);last=now;}
function wake(){lastEdge=-1;if(!raf)raf=requestAnimationFrame(frame)}
function syncClickthrough(){
 if(!clickthrough)return;
 // A visible CTA takes priority over whole-area navigation.
 const hasCTA=Array.from(promo.querySelectorAll('a[href],button,[role="button"],input[type="submit"]')).some(el=>
   el!==$('close')&&el!==$('playVideo')&&!el.hidden&&el.getAttribute('aria-hidden')!=='true'
 );
 const active=opened&&!hasCTA;
 clickthrough.hidden=!active;
 clickthrough.inert=!active;
 clickthrough.setAttribute('aria-hidden',String(!active));
}
function setOpen(next,method='unknown'){
 if(config.editorOpen)next=true;
 const changed=opened!==next;
 opened=next;rememberEditorState(opened);drag=null;const end=opened?maxEdge():rest();anim={from:edge,to:end,start:performance.now(),duration:reduced.matches?1:value('speed')};handle.setAttribute('aria-expanded',String(opened));handle.setAttribute('aria-label',opened?config.closeLabel:config.openLabel);promo.inert=!opened;promo.style.pointerEvents='none';promo.setAttribute('aria-hidden',String(!opened));syncClickthrough();idleStart=performance.now();syncVideo();wake();
 if(changed)track(opened?'page_peel_open':'page_peel_close',{interaction_method:method});
}
function updateMediaLayout(){
// Keep the media fixed at the top-right: the curl only alters the reveal mask.
const media=$('promoMedia');
media.style.width=W+'px';media.style.height=H+'px';
media.style.top='0';media.style.right='0';media.style.transform='none';
const v=$('backgroundVideo');
fullVideoFit=false;videoVisibleWidth=W;videoVisibleHeight=H;
if(v){
 const custom=config.layoutMode==='custom';
 const manual=custom&&config.cameraMode==='manual';
 // Desktop keeps its saved Custom fit/zoom/offsets when enabled. Below 990px,
 // responsive full-video framing is always the baseline, independent of desktop.
 const mobileBaseline={fit:'contain',zoom:100,focusX:50,focusY:50,offsetX:0,offsetY:0};
 const desktopBaseline=Object.assign({},mobileBaseline,{fit:custom?(config.video?.fit||'contain'):'contain'});
 const desktop=manual?Object.assign({},desktopBaseline,config.video||{}):desktopBaseline;
 // The simple focus adjustment has priority over old Custom mobile offsets.
 // Both choices leave the paper/reveal geometry fixed and independent.
 const simpleFocus=W<990&&Boolean(config.video?.focus?.enabled);
 const mobileOverride=custom&&W<990&&!simpleFocus&&Boolean(config.video?.mobileOverride);
 const selected=W<990
   ?(mobileOverride?Object.assign({},mobileBaseline,config.video?.mobile||{}):mobileBaseline)
   :desktop;
 const ref=Math.max(260,value('mediaFrame')||520);
 const offsetScale=W<990&&!mobileOverride?Math.min(1,W/ref):1;
 const zoom=simpleFocus
   ?Math.max(1,Math.min(1.6,Number(config.video?.focus?.zoom??125)/100))
   :Math.max(.5,Math.min(1.5,Number(selected.zoom||100)/100));
 const fx=Math.max(0,Math.min(100,Number(selected.focusX??50)));
 const fy=Math.max(0,Math.min(100,Number(selected.focusY??50)));
 const ox=Number(selected.offsetX||0)*offsetScale;
 const oy=Number(selected.offsetY||0)*offsetScale;
 // Shopify's preview image provides the aspect ratio before video metadata is ready.
 // Metadata takes precedence after loading; no breakpoint changes the source crop.
 const ratio=(v.videoWidth>0&&v.videoHeight>0?v.videoWidth/v.videoHeight:Number(config.videoAspect))||16/9;
 const aspect=Math.max(.4,Math.min(4,ratio));
 fullVideoFit=selected.fit!=='cover';
 if(fullVideoFit){
   // Fit the complete video inside the available stage, aligned to the top-right.
   // Its aspect ratio stays constant across all viewport widths.
   const naturalW=Math.min(W,H*aspect),naturalH=naturalW/aspect;
   v.style.width=naturalW+'px';v.style.height=naturalH+'px';
   v.style.objectFit='contain';
   // The fold follows the video layout footprint, NOT zoom or manual offsets.
   // Changing camera position must never resize or drag the curled paper.
   videoVisibleWidth=naturalW;videoVisibleHeight=naturalH;
 }else{
   // Intentional crop mode: preserve the original fill-the-stage behavior.
   v.style.width=W+'px';v.style.height=H+'px';
   v.style.objectFit='cover';
 }
 v.style.top='0';v.style.left='auto';v.style.right='0';v.style.bottom='auto';
 v.style.objectPosition=fx+'% '+fy+'%';
 if(simpleFocus&&fullVideoFit){
   // Scale about the video center and pan only within spare image coverage.
   // Bounds guarantee that both top/right endpoints of the triangular reveal
   // remain covered, without resizing the video frame or curl.
   const naturalW=videoVisibleWidth,naturalH=videoVisibleHeight;
   const spareX=Math.max(0,(zoom-1)*naturalW/2);
   const spareY=Math.max(0,(zoom-1)*naturalH/2);
   const targetTop=Math.min(Math.max(24,Math.min(W*.99,maxEdge()+(Number(config.creaseTop)||0))),naturalW);
   const targetRight=Math.min(Math.max(24,Math.min(H*.99,maxEdge()+(Number(config.creaseRight)||0))),naturalH);
   const minX=-spareX,maxX=spareX+Math.max(0,naturalW-targetTop);
   const minY=-spareY-Math.max(0,naturalH-targetRight),maxY=spareY;
   const focusX=Math.max(0,Math.min(1,Number(config.video.focus.x??50)/100));
   const focusY=Math.max(0,Math.min(1,Number(config.video.focus.y??50)/100));
   const dx=focusX<.5?(1-focusX*2)*minX:(focusX-.5)*2*maxX;
   const dy=focusY<.5?(1-focusY*2)*minY:(focusY-.5)*2*maxY;
   v.style.transformOrigin='center center';
   v.style.transform='translate('+dx+'px,'+dy+'px) scale('+zoom+')';
 }else{
   v.style.transformOrigin='top right';
   v.style.transform='translate('+ox+'px,'+oy+'px) scale('+zoom+')';
 }
 // Explicit Custom offsets may reveal the background; they never alter the curl.
}
// Promotional content is independent of video framing and crease motion.
promo.style.width='260px';promo.style.padding='18px';
promo.style.transformOrigin='top right';
promo.style.transform='scale('+Math.max(.72,Math.min(1,W/520))+')';
}
function resize(){const box=stage.getBoundingClientRect();if(drag)return;W=box.width;H=box.height;dpr=Math.min(devicePixelRatio||1,2);canvas.width=Math.round(W*dpr);canvas.height=Math.round(H*dpr);updateMediaLayout();texturePage();texturePixels=tx.getImageData(0,0,texture.width,texture.height);anim=null;edge=opened?maxEdge():rest();wake()}
function startDrag(e){if(config.editorOpen||drag||!e.isPrimary||(e.pointerType==='mouse'&&e.button!==0))return;anim=null;drag={id:e.pointerId,x:e.clientX,y:e.clientY,edge,moved:false,wasOpen:opened,pointerType:e.pointerType};try{e.currentTarget.setPointerCapture(e.pointerId)}catch(error){}stage.classList.add('is-dragging');syncVideo();e.preventDefault()}
function moveDrag(e){if(!drag||e.pointerId!==drag.id)return;const dx=drag.x-e.clientX,dy=e.clientY-drag.y;if(Math.hypot(dx,dy)>4)drag.moved=true;edge=Math.max(rest(),Math.min(maxEdge(),drag.edge+dx+dy));e.preventDefault();wake()}
function endDrag(e){if(!drag||drag.id!==e.pointerId)return;const d=drag,travel=edge-d.edge;drag=null;stage.classList.remove('is-dragging');const intentional=Math.abs(travel)>18;setOpen(d.moved?(intentional?travel>0:edge>(rest()+maxEdge())/2):!d.wasOpen,d.moved?'drag':(d.pointerType==='touch'?'touch':'pointer'))}
function cancel(e){if(drag&&(!e||e.pointerId===drag.id)){let state=drag.wasOpen;drag=null;stage.classList.remove('is-dragging');setOpen(state)}}
let lastTouch=0;
function touchPoint(e,t){return {pointerId:t.identifier,isPrimary:true,pointerType:'touch',clientX:t.clientX,clientY:t.clientY,currentTarget:e.currentTarget,preventDefault:()=>{if(e.cancelable)e.preventDefault()}}}
function touchStart(e){if(e.touches.length!==1||drag)return;lastTouch=performance.now();startDrag(touchPoint(e,e.changedTouches[0]));e.stopPropagation()}
function touchMove(e){if(!drag)return;const t=Array.from(e.changedTouches).find(t=>t.identifier===drag.id);if(t){moveDrag(touchPoint(e,t));e.stopPropagation()}}
function touchEnd(e){if(!drag)return;const t=Array.from(e.changedTouches).find(t=>t.identifier===drag.id);if(t){moveDrag(touchPoint(e,t));endDrag(touchPoint(e,t));lastTouch=performance.now();e.stopPropagation()}}
for(const surface of [handle,$('foldHit')]){
 surface.addEventListener('touchstart',touchStart,{passive:false,capture:true,signal});
 surface.addEventListener('pointerdown',e=>{if(e.pointerType==='touch'||performance.now()-lastTouch<700)return;startDrag(e)},{passive:false,signal});
 surface.addEventListener('contextmenu',e=>e.preventDefault(),{signal});
}
window.addEventListener('touchmove',touchMove,{passive:false,capture:true,signal});
window.addEventListener('touchend',touchEnd,{passive:false,capture:true,signal});
window.addEventListener('touchcancel',touchEnd,{passive:false,capture:true,signal});
window.addEventListener('pointermove',e=>{if(e.pointerType!=='touch')moveDrag(e)},{passive:false,capture:true,signal});
window.addEventListener('pointerup',e=>{if(e.pointerType!=='touch')endDrag(e)},{capture:true,signal});
window.addEventListener('pointercancel',e=>{if(e.pointerType!=='touch')endDrag(e)},{capture:true,signal});
handle.addEventListener('click',e=>{if(e.detail===0&&performance.now()-lastTouch>700)setOpen(!opened,'keyboard')},{signal});$('close').addEventListener('click',()=>{setOpen(false,'close_button');handle.focus()},{signal});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&opened){setOpen(false,'escape');handle.focus()}},{signal});
// Count only actual navigational links, never a tap on the flap/canvas itself.
if(clickthrough)clickthrough.addEventListener('click',e=>{
 trackClickthrough(clickthrough,'full_reveal',e.detail===0?'keyboard':'pointer');
},{signal});
promo.addEventListener('click',e=>{
 const anchor=e.target instanceof Element?e.target.closest('a[href]'):null;
 if(anchor&&promo.contains(anchor))trackClickthrough(anchor,'promo_link',e.detail===0?'keyboard':'pointer');
},{signal});
const video=$('backgroundVideo');
if(video){
 video.addEventListener('loadedmetadata',()=>{if(root.isConnected&&W&&H){updateMediaLayout();wake();}},{signal});
 video.addEventListener('play',()=>{track('page_peel_video_play',{play_method:drag?'drag':opened?'peel_open':'manual'});},{signal});
}
// Preload metadata immediately for sizing; warm video data after the main page load,
// on browser idle, or sooner when the visitor approaches the curl. Do not autoplay.
let videoWarmed=false,videoWarmIdle=null,videoWarmTimer=null;
function warmVideo(){
 if(!video||videoWarmed||!root.isConnected||document.hidden)return;
 videoWarmed=true;
 video.preload='auto';
 if(video.readyState<3)video.load();
}
function queueVideoWarmup(){
 if(!video||videoWarmed||videoWarmIdle!==null||videoWarmTimer!==null||document.hidden||reduced.matches||navigator.connection?.saveData)return;
 if(typeof window.requestIdleCallback==='function'){
   videoWarmIdle=window.requestIdleCallback(()=>{videoWarmIdle=null;warmVideo();},{timeout:2500});
 }else{
   videoWarmTimer=window.setTimeout(()=>{videoWarmTimer=null;warmVideo();},900);
 }
}
if(document.readyState==='complete')queueVideoWarmup();
else window.addEventListener('load',queueVideoWarmup,{once:true,signal});
if(video)for(const hotspot of [handle,$('foldHit')]){
 hotspot.addEventListener('pointerenter',warmVideo,{signal});
 hotspot.addEventListener('focusin',warmVideo,{signal});
}
// Android may reject a play() promise while media is loading or when another
// play/pause races the fold animation. Only surface a tap affordance for a real
// autoplay policy rejection; retry loading failures on canplay instead.
const playButton=$('playVideo');
let playPending=false,pendingGeneration=-1,playGeneration=0,videoRetryTimer=null;
const shouldPlayVideo=()=>Boolean(video&&!document.hidden&&(opened||drag)&&!reduced.matches);
const setPlayPrompt=visible=>{if(playButton)playButton.hidden=!visible;};
function attemptVideoPlayback(){
 if(!shouldPlayVideo()||(playPending&&pendingGeneration===playGeneration))return;
 // Explicit muted/inline playback is permitted on Android Chrome and iOS Safari.
 video.muted=true;video.defaultMuted=true;video.playsInline=true;
 warmVideo();playPending=true;
 const generation=playGeneration;
 pendingGeneration=generation;
 let promise;
 try{promise=video.play();}catch(error){promise=Promise.reject(error)}
 Promise.resolve(promise).then(()=>{
   if(generation===pendingGeneration)playPending=false;
   if(generation!==playGeneration||!shouldPlayVideo())return;
   setPlayPrompt(false);
 }).catch(error=>{
   if(generation===pendingGeneration)playPending=false;
   if(generation!==playGeneration||!shouldPlayVideo())return;
   if(error?.name==='NotAllowedError'){
     setPlayPrompt(true);
   }else if(!video.error){
     // AbortError / NotSupportedError during startup may be temporary; wait
     // for media readiness rather than showing an unstyled white button.
     setPlayPrompt(false);
     if(video.readyState>=2){
       clearTimeout(videoRetryTimer);
       videoRetryTimer=setTimeout(()=>{videoRetryTimer=null;attemptVideoPlayback()},600);
     }
   }else{
     // A genuinely unsupported source still offers accessible manual playback.
     setPlayPrompt(true);
   }
 });
}
function syncVideo(){
 if(!video)return;
 if(shouldPlayVideo()){setPlayPrompt(false);attemptVideoPlayback()}
 else{
   playGeneration++;
   clearTimeout(videoRetryTimer);videoRetryTimer=null;
   setPlayPrompt(false);video.pause();
 }
}
if(video){
 video.addEventListener('canplay',()=>{if(shouldPlayVideo()&&video.paused)attemptVideoPlayback()},{signal});
 video.addEventListener('playing',()=>setPlayPrompt(false),{signal});
 video.addEventListener('stalled',()=>{if(shouldPlayVideo())setPlayPrompt(false)},{signal});
}
playButton?.addEventListener('click',()=>{if(!video)return;setPlayPrompt(false);attemptVideoPlayback()},{signal});
reduced.addEventListener('change',()=>{syncVideo();wake()},{signal});const observer=new ResizeObserver(resize);observer.observe(stage);
document.addEventListener('visibilitychange',()=>{syncVideo();if(document.hidden){cancelAnimationFrame(raf);raf=0}else{queueVideoWarmup();wake()}},{signal});
this.cleanup=()=>{impressionObserver?.disconnect();headerObserver.disconnect();ac.abort();clearTimeout(refreshTimer);if(videoWarmIdle!==null&&typeof window.cancelIdleCallback==='function')window.cancelIdleCallback(videoWarmIdle);if(videoWarmTimer!==null)clearTimeout(videoWarmTimer);for(const entry of imageCache.values()){entry.image.onload=null;entry.image.onerror=null}imageCache.clear();observer.disconnect();cancelAnimationFrame(raf);if(video)video.pause()};if(config.editorOpen||readEditorState())setOpen(true);if(config.editorOpen){$('close').hidden=true;handle.hidden=true;$('foldHit').style.pointerEvents='none';}resize();refreshTexture();
if(trackEnabled){
 if(typeof IntersectionObserver==='function'){
  impressionObserver=new IntersectionObserver(entries=>{
    if(entries.some(entry=>entry.isIntersecting&&entry.intersectionRatio>0))trackImpression();
  },{threshold:0});
  impressionObserver.observe(handle);
 }else if(handle.getBoundingClientRect().width>0)trackImpression();
}
} disconnectedCallback(){this.cleanup?.();this.cleanup=null}
});
})();








